import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::admin'

export default pipe(
  modelComposition(descriptor),
)
